import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { SilaeVariable } from "@/types/silae";

interface SilaeVariablesState {
  variables: SilaeVariable[];
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
  lastFetchedAt: string | null;
}

const initialState: SilaeVariablesState = {
  variables: [],
  isLoading: false,
  isLoaded: false,
  error: null,
  lastFetchedAt: null,
};

const silaeVariablesSlice = createSlice({
  name: "silaeVariables",
  initialState,
  reducers: {
    fetchVariablesStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchVariablesSuccess: (state, action: PayloadAction<SilaeVariable[]>) => {
      state.variables = action.payload;
      state.isLoading = false;
      state.isLoaded = true;
      state.error = null;
      state.lastFetchedAt = new Date().toISOString();
    },
    fetchVariablesFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.isLoaded = true; // Marquer comme chargé même en cas d'erreur pour éviter les boucles infinies
      state.error = action.payload;
    },
    clearVariables: (state) => {
      state.variables = [];
      state.isLoaded = false;
      state.lastFetchedAt = null;
    },
  },
});

export const {
  fetchVariablesStart,
  fetchVariablesSuccess,
  fetchVariablesFailure,
  clearVariables,
} = silaeVariablesSlice.actions;

export default silaeVariablesSlice.reducer;
